import * as React from 'react';

import { Person } from '../gs-core/common';

interface PersonTitleProps { person: Person; }

export const PersonTitle = ({ person }: PersonTitleProps) => {
  return person && person.primaryTitle ?
    (
      <div className="text-muted">
        {person.primaryTitle}{person.homeDepartmentName && <span> in {person.homeDepartmentName}</span>}
      </div>
    ) : null;
};



// WEBPACK FOOTER //
// ./src/Subject/PersonTitle.tsx